module.exports = __webpack_public_path__ + "static/media/img-home2.62e5b075.jpg";